module.exports = __webpack_public_path__ + "img/PoorPeoplesCampaign.710b14ad.jpg";